export default {
  spinner: {
    show: false,
    title: "",
    subtitle: ""
  },
  notification: {
    show: false,
    type: null,
    message: ""
  },
  modal: {
    show: false,
    type: null
  },
  user: null,
  initialAframe: false,
  scrollBlock: {
    block: null,
    positionScrollY: 0
  },
  connected: false
};
